export default __webpack_public_path__ + "static/media/Group 4070.4b1db515.svg";